import { registerPlugin } from '@capacitor/core';
import { isAndroid } from './Platform';

/**
 * Picture-in-Picture wiring.
 *
 * - **Android**: flag the native Activity as "PiP eligible" so that when
 *   the user presses Home or Overview while playing, the Activity shrinks
 *   into a floating window (MainActivity.onUserLeaveHint → enterPiP).
 * - **iOS**: PiP is driven by the HTML5 `<video>` element itself — set
 *   `playsinline` + `autoPictureInPicture` on the element and iOS will
 *   pop a floating player automatically when the app is backgrounded.
 *   `enableForVideoElement()` does the HTML attribute wiring.
 */
const PictureInPictureController = registerPlugin('PictureInPictureController');

export async function setEligible(eligible) {
    if (!isAndroid()) return;
    try {
        await PictureInPictureController.setEligible({
            eligible: !!eligible
        });
    } catch (err) {
        console.warn('[PictureInPicture] setEligible failed', err);
    }
}

/**
 * Apply PiP-friendly attributes to an HTML5 `<video>` element so iOS
 * and desktop browsers will auto-enter PiP on backgrounding.
 */
export function enableForVideoElement(videoEl) {
    if (!videoEl) return;
    try {
        videoEl.setAttribute('playsinline', 'true');
        videoEl.setAttribute('webkit-playsinline', 'true');
        videoEl.setAttribute('autoPictureInPicture', 'true');
        // Ensure the attribute is reflected as a property on iOS 14+.
        if ('autoPictureInPicture' in videoEl) {
            videoEl.autoPictureInPicture = true;
        }
        videoEl.disablePictureInPicture = false;
    } catch (_) {
        /* non-fatal */
    }
}

export default { setEligible, enableForVideoElement };
